import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const AdminOrganizationInvitationsListPage = () => {
  return (
    <>
      <Helmet>
        <title>Organization Invitations list - AutoScript Admin</title>
      </Helmet>
      <Content />
    </>
  );
};
